<template>
  <el-drawer :wrapperClosable="true" :title="title" :visible.sync="informationFlag" size="50%" direction="rtl"
             :before-close="handleClose">

    <div class="demo-drawer__content">

      <el-form :model="addFrom" :rules="rules" ref="ruleForm" v-loading="loading">
        <el-row :gutter="35">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="制作机构" :label-width="formLabelWidth" prop="production_organisation">
              <el-input v-model="addFrom.production_organisation" placeholder="请输入制作机构"
                        style="width: 85%;" clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="发行年份" :label-width="formLabelWidth" prop="produce_year">
              <el-select v-model="addFrom.produce_year" placeholder="请选择发行年份" clearable
                         style="width: 85%;">
                <el-option v-for="dict in produceYearList" :key="dict.id" :label="dict.name"
                           :value="dict.name"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="导演" prop="director" :label-width="formLabelWidth">
              <div style="display: flex;">
                <SelectChecked :options="directorOptions" :isRemoveAllTag="isRemoveAllTag"
                               style="width: 85%;" placeholder="请选择导演" @selectedVal="selectedDirector"/>
                <img @click="Addactor"
                     style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                     src="@/assets/btn/xinzeng.png" alt="">
                <img @click="AddRefreshActor"
                     style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                     src="@/assets/btn/shuaxin.png" alt="">
              </div>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="制作人" prop="producer" :label-width="formLabelWidth">
              <div style="display: flex;">
                <SelectChecked :options="producerOptions" :isRemoveAllTag="isRemoveAllTag"
                               style="width: 85%;" placeholder="请选择制作人" @selectedVal="selectedProducer"/>
                <img @click="Addactor"
                     style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                     src="@/assets/btn/xinzeng.png" alt="">
                <img @click="AddRefreshActor"
                     style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                     src="@/assets/btn/shuaxin.png" alt="">
              </div>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="演员1" prop="actor_1" :label-width="formLabelWidth">
              <div style="display: flex;">
                <el-select v-model="addFrom.actor_1" placeholder="请选择演员1" filterable clearable style="width: 85%;">
                  <el-option v-for="dict in actorOptions" :key="dict.id" :label="dict.label"
                             :value="dict.label"/>
                </el-select>
                <img @click="Addactor"
                     style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                     src="@/assets/btn/xinzeng.png" alt="">
                <img @click="AddRefreshActor"
                     style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                     src="@/assets/btn/shuaxin.png" alt="">
              </div>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="饰演角色1" prop="role_1" :label-width="formLabelWidth">
              <div style="display: flex;">
                <el-input v-model="addFrom.role_1" placeholder="请输入饰演角色1"
                          style="width: 85%;" clearable></el-input>

              </div>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="演员2" prop="actor_2" :label-width="formLabelWidth">
              <div style="display: flex;">
                <el-select v-model="addFrom.actor_2" placeholder="请选择演员2" filterable clearable style="width: 85%;">
                  <el-option v-for="dict in actorOptions" :key="dict.id" :label="dict.label"
                             :value="dict.label"/>
                </el-select>
                <img @click="Addactor"
                     style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                     src="@/assets/btn/xinzeng.png" alt="">
                <img @click="AddRefreshActor"
                     style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                     src="@/assets/btn/shuaxin.png" alt="">
              </div>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="饰演角色2" prop="role_2" :label-width="formLabelWidth">
              <div style="display: flex;">
                <el-input v-model="addFrom.role_2" placeholder="请输入饰演角色2"
                          style="width: 85%;" clearable></el-input>

              </div>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">

            <el-form-item label="类目标签(1-3个)" prop="b_tag_id" :label-width="formLabelWidth">
              <SelectChecked :options="tagOptions" :isRemoveAllTag="isRemoveAllTag" style="width: 85%;"
                             placeholder="请选择类目" @selectedVal="selectedTags"/>
            </el-form-item>

            <el-form-item label="平均单集时长(分钟)" prop="duration" :label-width="formLabelWidth">
              <el-input v-model="addFrom.duration" type="number" placeholder="请输入平均单集时长"
                        style="width: 85%;" clearable @input="handledurationlInput"></el-input>
            </el-form-item>

            <el-form-item label="成本配置比例" :label-width="formLabelWidth" prop="cost_distribution_uri">
              <el-upload class="avatar-uploader" action
                         :http-request="(file) => httpDistributionRequest(file)" :show-file-list="false"
                         accept=".jpg,.png,.jpeg,.bmp,.webp"
                         :on-success="handleDistributionSuccess" :before-upload="beforeAvatarUpload">
                <img v-if="cost_distribution_uri" :src="cost_distribution_uri" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon" style="border:1px solid #ccc;"></i>
              </el-upload>
            </el-form-item>

            <el-form-item label="承诺书" :label-width="formLabelWidth" prop="promise_uri">
              <el-upload class="avatar-uploader" action
                         :http-request="(file) => httpPromiseRequest(file)" :show-file-list="false"
                         accept=".jpg,.png,.jpeg,.bmp,.webp"
                         :on-success="handlePromiseSuccess" :before-upload="beforeAvatarUpload">
                <img v-if="promise_uri" :src="promise_uri" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon" style="border:1px solid #ccc;"></i>
              </el-upload>
            </el-form-item>

          </el-col>

        </el-row>
      </el-form>
    </div>
    <div class="demo-drawer__footer">
      <el-button @click="AddNone">取 消</el-button>
      <el-button type="primary" @click="addPush" :loading="loading">确 定</el-button>
    </div>
  </el-drawer>
</template>

<script>
import {WorksListAPI} from '@/api/Works/WorksList';
import {processErrors} from "@/utils/errorHandler";
import {administratorsAPI} from '@/api/account/administrators';
import SelectChecked from '@/components/Select/SelectChecked'
import {CastCrewAPI} from '@/api/Works/CastCrew';

export default {
  props: ['informationFlag', "InfoeditID"],
  components: {
    SelectChecked
  },
  data() {
    return {
      formLabelWidth: "140px",
      title: "新增",
      addFrom: {
        name: "",
        origin_name: "",
        book_name: "",
        cp_name: "",
        cover: "",
        source: 0,
        status: 1,
        visible: 0,
        episode_total: "",
        is_open_zrll: 0,
        charge_type: "1",
        episode_price: "",
        free_episode_total: "",
        description: "",
        category_id: "",
        level: "",
        tags: "",
        follows_count: "",
        cansee: 0,
        visible_channels: "",
        combine: 0,
        sequence: "",
        redirect: "",
        onself_time: "",
        id: "",
        is_iaa: 0,
        ad_priority: 1,
        duration: 2,
        is_douyin: 1,
        produce_year: ''
      },
      rules: {
        combine: [
          {required: true, message: '请选择', trigger: 'change'}
        ],
        cover: [
          {required: true, message: '请选择图片', trigger: 'blur'},
        ],
        description: [
          {required: true, message: '请输入剧情描述', trigger: 'blur'},
        ],
        recommendation: [
          {required: true, message: '请输入推荐语', trigger: 'blur'},
        ],
        episode_total: [
          {required: true, message: '请输入剧集总数', trigger: 'blur'},
        ],
        cansee: [
          {required: true, message: '请选择', trigger: 'change'}
        ],
        sequence: [
          {required: true, message: '请输入排序', trigger: 'blur'},
        ],
        name: [
          {required: true, message: '请输入小说名称', trigger: 'blur'},
        ],
        episode_price: [
          {required: true, message: '请输入单集价格', trigger: 'blur'},
        ],
        free_episode_total: [
          {required: true, message: '请输入免费集数总数', trigger: 'blur'},
        ],
        follows_count: [
          {required: true, message: '请输入追剧人数', trigger: 'blur'},
        ],
        copyright_id: [
          {required: true, message: '请选择版权方', trigger: 'change'}
        ],
        produce_year: [
          {required: true, message: '请选择发行年份', trigger: 'change'}
        ],
        production_organisation: [
          {required: true, message: '请输入制作机构', trigger: 'blur'},
        ],
        actor_1: [
          {required: true, message: '请选择演员1', trigger: 'blur'},
        ],
        actor_2: [
          {required: true, message: '请选择演员2', trigger: 'blur'},
        ],
        b_tag_id: [
          {required: true, message: '', trigger: 'blur', validator: this.validateBTag}
        ],
        director: [
          {required: true, message: '请选择导演', trigger: 'blur'},
        ],
        producer: [
          {required: true, message: '请选择制作人', trigger: 'blur'},
        ],
        cost_distribution_uri: [
          {required: true, message: '请上传成本配置比例情况', trigger: 'blur'},
        ],
        promise_uri: [
          {required: true, message: '请上传承诺书', trigger: 'blur'},
        ],
        duration: [
          {required: true, message: '', trigger: 'blur', validator: this.validateDuration},
        ],
        role_1: [
          {required: true, message: '请输入演员1的饰演角色', trigger: 'blur'},
        ],
        role_2: [
          {required: true, message: '请输入演员2的饰演角色', trigger: 'blur'},
        ],
      },
      nameRole: "优化师",
      appidList: [],
      EditFlag: false,
      imageUrl: "",
      loading: false,
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      copyrightList: [],
      tagOptions: [],
      isRemoveAllTag: 0,
      cost_distribution_uri: '',
      promise_uri: '',
      produceYearList: [],
      directorOptions: [],
      producerOptions: [],
      actorOptions: [],
      active: 1,
      inactive: 0,
    };
  },
  created() {
    this.getclassifyList()
    this.getCopyRightList()
    this.setYearList()
  },
  methods: {
    // 表单校验规则-类目标签
    validateBTag(rule, value, callback) {
      if (!value) {
        return callback(new Error('请选择类目标签'));
      }else if(value.split(',').length>3){
        return callback(new Error('类目标签不超过 3 个'));
      }else{
        return callback();
      }
    },
    // 表单校验规则-平均单集时长
    validateDuration(rule, value, callback) {
      if (!value) {
        return callback(new Error('请输入平均单集时长'));
      }else if(value == 0){
        return callback(new Error('平均单集时长不能为 0'));
      }else{
        return callback();
      }
    },
    handledurationlInput(value) {
      // 强制只允许输入数字
      this.addFrom.duration = value.replace(/[^\d]/g, ''); // 使用正则表达式替换非数字字符
    },
    handlesequenceInput(value) {
      // 强制只允许输入数字
      this.addFrom.sequence = value.replace(/[^\d]/g, ''); // 使用正则表达式替换非数字字符
    },
    handleAvatarSuccess(res, file) {
      this.addFrom.cover = URL.createObjectURL(file.raw);
    },

    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
    },

    /**
     * 获取抖音类目标签列表
     */
    getTagOptions() {
      let api = WorksListAPI()
      api.getTags().then((res) => {
        let data = res.data;
        this.tagOptions = data.map(item => ({
          value: item.tag_id,
          label: item.tag_name,
          check: false
        }));

        if (this.addFrom && this.addFrom.b_tag_id) {
          // 将逗号分隔的字符串转换为数组
          const b_tag_idValues = this.addFrom.b_tag_id.split(',').map(Number); // 转换为数字数组

          this.tagOptions.forEach(b_tag_id => {
            if (b_tag_idValues.includes(b_tag_id.value)) {
              b_tag_id.check = true; // 如果包含，设置 check 为 true
            }
          });
        }

      });
    },

    getCastCrewOptions() {
      let api = CastCrewAPI();
      let params = {
        pageNo: 1,
        pageSize: 99999,
      };

      api.getCastCrewList(params).then(res => {
        if (res.code === 0) {
          let data = res.data.data;

          // 检查 data 是否为数组
          if (!Array.isArray(data)) {
            console.error('Expected data to be an array, but got:', data);
            return; // 如果不是数组，直接返回
          }

          // 初始化三个数组
          this.directorOptions = [];
          this.producerOptions = [];
          this.actorOptions = [];

          // 按类型分组数据
          data.forEach(item => {
            const option = {
              value: item.id,
              label: item.name,
              check: false
            };

            switch (item.type) {
              case 1: // 导演
                this.directorOptions.push(option);
                break;
              case 2: // 制作人
                this.producerOptions.push(option);
                break;
              case 3: // 演员
                this.actorOptions.push(option);
                break;
              default:
                break; // 处理其他类型（如果有）
            }
          });
          if (this.addFrom && this.addFrom.director) {
            // 将逗号分隔的字符串转换为数组
            const directorValues = this.addFrom.director.split(',').map(Number); // 转换为数字数组

            this.directorOptions.forEach(director => {
              if (directorValues.includes(director.value)) {
                director.check = true; // 如果包含，设置 check 为 true
              }
            });
          }

          if (this.addFrom && this.addFrom.producer) {
            // 将逗号分隔的字符串转换为数组
            const producerValues = this.addFrom.producer.split(',').map(Number); // 转换为数字数组

            this.producerOptions.forEach(producer => {
              if (producerValues.includes(producer.value)) {
                producer.check = true; // 如果包含，设置 check 为 true
              }
            });
          }

          // if (this.addFrom && this.addFrom.actor) {
          //     // 将逗号分隔的字符串转换为数组
          //     const actorValues = this.addFrom.actor.split(',').map(Number); // 转换为数字数组

          //     this.actorOptions.forEach(actor => {
          //         if (actorValues.includes(actor.value)) {
          //             actor.check = true; // 如果包含，设置 check 为 true
          //         }
          //     });
          // }
        } else {
          processErrors(res);
        }
      }).catch(error => {
        console.error('Error fetching cast crew list:', error);
      });
    },

    //选择抖音类目
    selectedTags(value) {
      this.addFrom.b_tag_id = value.join(',');
    },

    //选择导演
    selectedDirector(value) {
      this.addFrom.director = value.join(',');
    },

    //选择制作人
    selectedProducer(value) {
      this.addFrom.producer = value.join(',');
    },

    //选择演员
    selectedActor(value) {
      this.addFrom.actor = value.join(',');
    },

    /**
     * 设置年份列表
     */
    setYearList() {
      const currentYear = new Date().getFullYear(); // 获取当前年份
      this.produceYearList = []; // 清空数组
      for (let i = 0; i < 5; i++) {
        const year = currentYear - i;
        this.produceYearList.push({id: i + 1, name: year}); // 添加对象到数组
      }

    },

    httpDistributionRequest(file) {
      let api = WorksListAPI()
      this.cost_distribution_uri = new FormData();
      this.cost_distribution_uri.append("file", file.file);

      api.fileDistributionUpload(this.cost_distribution_uri).then((res) => {
        if (res.code == 0) {
          this.cost_distribution_uri = res.data.url_full;
          this.addFrom.cost_distribution_uri = res.data.url;
        } else {
          processErrors(res);
        }
      });
    },

    handleDistributionSuccess(res, file) {
      this.addFrom.cost_distribution_uri = URL.createObjectURL(file.raw);
    },

    httpPromiseRequest(file) {
      let api = WorksListAPI()
      this.promise_uri = new FormData();
      this.promise_uri.append("file", file.file);

      api.filePromiseUpload(this.promise_uri).then((res) => {
        if (res.code == 0) {
          this.promise_uri = res.data.url_full;
          this.addFrom.promise_uri = res.data.url;
        } else {
          processErrors(res);
        }
      });
    },

    handlePromiseSuccess(res, file) {
      this.addFrom.promise_uri = URL.createObjectURL(file.raw);
    },

    httpRequest(file) {
      let api = WorksListAPI()
      this.imageUrl = new FormData();
      this.imageUrl.append("file", file.file);

      api.fileUpload(this.imageUrl).then((res) => {
        if (res.code == 0) {
          this.imageUrl = res.data.url_full;
          this.addFrom.cover = res.data.url;
        } else {
          processErrors(res);
        }
      });
    },
    /**
     * 获取版权方列表
     */
    getCopyRightList() {
      let api = administratorsAPI()
      let adminParams = {
        pageNo: 1,
        pageSize: 10000,
        group: 11
      }
      api.administratorsList(adminParams).then(res => {
        if (res.code == 0) {
          this.copyrightList = res.data.data
        } else {
          processErrors(res);
        }
      })
    },
    getclassifyList() {
      let api = WorksListAPI()
      api.classifyList(this.page).then(res => {
        if (res.code == 0) {
          this.appidList = res.data
        } else {
          processErrors(res);
        }
      })
    },
    handleClose(done) {
      this.$emit('InfoNoneDlog')
      this.$refs['ruleForm'].resetFields();
    },
    AddNone() {
      this.addFrom = {
        name: "",
        origin_name: "",

        cp_name: "",
        cover: "",
        source: "",
        status: "",
        visible: "",
        episode_total: "",
        is_open_zrll: "",
        charge_type: "1",
        episode_price: "",
        free_episode_total: "",
        description: "",
        category_id: "",
        level: "",
        tags: "",
        follows_count: "",
        cansee: "0",
        visible_channels: "",
        combine: "",
        sequence: "",
        redirect: "",
        copyright_id: "",
        onself_time: "",
        id: "",
        is_iaa: 0,
        ad_priority: 1
      }
      this.$refs['ruleForm'].resetFields();
      this.$emit('InfoNoneDlog');
    },

    addPush() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.loading = true;
          let api = WorksListAPI()
          if (this.addFrom.id == "") {
            api.getresourcesy(this.addFrom).then(res => {
              if (res.code == 0) {
                this.$message({
                  message: '创建成功',
                  type: 'success'
                });
                this.$emit('InfoAddOk');
              } else {
                processErrors(res);
              }

            })
          } else {
            api.getresourcesy(this.addFrom).then(res => {
              if (res.code == 0) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                this.$emit('InfoAddOk');
              } else {
                processErrors(res);
              }

            })
          }
          this.loading = false;
        } else {

          return false;
        }
      });
    },
    Addactor() {
      const baseExportUrl = new URL(window.location.href).origin;
      let url = baseExportUrl + '/#/WorksManagement/CastCrew';
      window.open(url);
    },
    AddRefreshActor() {
      this.getCastCrewOptions()
    }
  },

  mounted() {
    if (this.InfoeditID != "") {
      this.loading = true;
      let api = WorksListAPI()
      api.medialsList(this.InfoeditID).then(res => {
        if (res.code == 0) {
          this.imageUrl = res.data.full_cover
          this.cost_distribution_uri = res.data.full_cost_distribution_uri
          this.promise_uri = res.data.full_promise_uri
          this.title = "编辑"
          this.addFrom = res.data
          this.$nextTick(() => {
            if (this.produceYearList.length > 0 && !res.data.produce_year) {
              this.addFrom.produce_year = this.produceYearList[0].name;
            }
          });
          !res.data.duration ? this.addFrom.duration = 2 : ''
          this.loading = false;
          this.getCastCrewOptions();
          this.getTagOptions();
        } else {
          processErrors(res);
        }
      })
    } else {
      this.getCastCrewOptions()
      this.getTagOptions()
    }

  },
}
</script>
<style lang='scss' scoped>
.Box {
  & ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 0 !important;
    }
  }
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
}

.demo-drawer__footer .el-button {
  //flex: 1; /* 让按钮平分容器宽度 */
  width: 320px;
  /* 设置按钮宽度为120px */
}

.demo-drawer__content {
  height: calc(100% - 80px);
  /* 给内容区域设置高度,留出按钮区域 */
  overflow-y: auto;
  /* 添加垂直滚动条 */
  margin-top: 20px;
  overflow-x: hidden;
}

::v-deep .el-drawer__close-btn {
  font-size: 30px;
  font-weight: bold;
}
</style>